import { Model } from '~contentful/models/model';

export abstract class ComponentModel extends Model {
  public abstract readonly componentClass: any;
}
